<div class="container-fluid">
    <div class="row">
        <div class="card p-0">
            <div class="row m-0">
                <div class="col-sm-6 hidden-mobile left-image">
                </div>
                <div class="col-sm-6  form-div">
                    <img src="../../../../../assets/Logo-new.svg" class="pt-3">
                    <h6>Enter OTP</h6>
                    <form name="form" class="p-2" (submit)="loginForm.form.valid && onSignIn(loginForm)"
                        #loginForm="ngForm" novalidate>
                        <div class="form-row">
                            <div class="form-group col">
                                <input type="number" name="username" class="form-control" placeholder="Enter OTP" appDisableCopyPaste
                                    [(ngModel)]="model.username" #username="ngModel" maxlength="6" 
                                    [ngClass]="{ 'is-invalid-border': loginForm.submitted && username.invalid }"
                                    required>
                                <div *ngIf="loginForm.submitted && username.invalid" class="invalid-feedback-text">
                                    <div *ngIf="username.errors.required">OTP is required</div>
                                </div>
                            </div>
                        </div>
                        <div class="text-center mt-4 ">
                            <button class="btn  mr-1 mb-2" type="submit">Submit</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>